var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1117_5019)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1117_5019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1117_5019)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 0C1.00736 0 0 1.00736 0 2.25V20.25C0 21.4926 1.00736 22.5 2.25 22.5H9.375C9.99632 22.5 10.5 21.9963 10.5 21.375C10.5 20.7537 9.99632 20.25 9.375 20.25H3C2.58579 20.25 2.25 19.9142 2.25 19.5V3C2.25 2.58579 2.58579 2.25 3 2.25H18C18.4142 2.25 18.75 2.58579 18.75 3V9.375C18.75 9.99632 19.2537 10.5 19.875 10.5C20.4963 10.5 21 9.99632 21 9.375V2.25C21 1.00736 19.9926 0 18.75 0H2.25ZM4.5 7.125C4.5 6.50369 5.00369 6 5.625 6L15.375 5.99997C15.9963 5.99997 16.5 6.50366 16.5 7.12497C16.5 7.74629 15.9963 8.24997 15.375 8.24997L5.625 8.25C5.00369 8.25 4.5 7.74632 4.5 7.125ZM5.625 10.5C5.00369 10.5 4.5 11.0037 4.5 11.625C4.5 12.2463 5.00369 12.75 5.625 12.75H10.875C11.4963 12.75 12 12.2463 12 11.625C12 11.0037 11.4963 10.5 10.875 10.5H5.625ZM13.7579 13.7568C13.3185 14.1962 13.3185 14.9085 13.7579 15.3479L16.4108 18.0008L13.7586 20.6529C13.3193 21.0923 13.3193 21.8046 13.7586 22.244C14.198 22.6833 14.9103 22.6833 15.3497 22.244L18.0018 19.5918L20.6522 22.2422C21.0915 22.6815 21.8039 22.6815 22.2432 22.2422C22.6826 21.8028 22.6826 21.0905 22.2432 20.6511L19.5929 18.0008L22.244 15.3497C22.6833 14.9103 22.6833 14.198 22.244 13.7587C21.8046 13.3193 21.0923 13.3193 20.6529 13.7587L18.0018 16.4099L15.3489 13.7568C14.9095 13.3175 14.1972 13.3175 13.7579 13.7568Z",
    fill: "#42474D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1117_5019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.150ee8e4e9ee82f165fc1293ccc1bc41.svg";
export { ForwardRef as ReactComponent };